import { useContext, useMemo, useState, useEffect } from "react";
import { ScheduleContext } from "context/schedule";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CreateEventModal from "./components/CreateEventModal";
import CalendarView from "./components/CalendarView";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import Swal from "sweetalert2";

// MUI
import { useMaterialUIController, AuthContext } from "context";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import HttpService from "services/htttp.service";

function Schedule() {
    const { user, setUser } = useContext(AuthContext);
    const { schedule, loading } = useContext(ScheduleContext);
    const [openModal, setOpenModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [controller] = useMaterialUIController();
    const { sidenavColor } = controller;

    // Obter data de hoje para validação
    const getTodayDate = () => {
      const today = new Date();
      return today.toISOString().split('T')[0];
    };
    
    const todayDate = getTodayDate();



    const STATUS_COLORS = {
        draft: "#9e9e9e",       // cinza
        confirmed: "#1976d2",   // azul
        completed: "#2e7d32",   // verde
        cancelled: "#d32f2f",   // vermelho
    };

    const calendarEvents = useMemo(() => {
        if (!schedule || schedule.length === 0) return [];

        return schedule.map((event) => {
            const date = event.event_date.split("T")[0]; // remove timezone
            const color = STATUS_COLORS[event.status] || "#1976d2";

            return {
                id: event.id,
                title: event.title,
                start: event.start_time
                    ? `${date}T${event.start_time}`
                    : date,
                allDay: !event.start_time,
                backgroundColor: color,
                borderColor: color,
                textColor: "#fff",
            };
        });
    }, [schedule]);

    const handleGoogleConnect = async () => {
        try {
            // Tenta obter a URL de redirecionamento do backend (geralmente retorna { url: "https://accounts.google.com/..." })
            const response = await HttpService.get("auth/google/redirect");
            const url = response.url || response.data?.url;
            
            if (url) {
                window.location.href = url;
            } else {
                // Fallback caso a rota faça um redirect (302) nativo e não devolução de JSON
                Swal.fire("Atenção", "Resposta inesperada ao tentar conectar com o Google.", "warning");
            }
        } catch (error) {
            console.error("Erro ao conectar com Google:", error);
            Swal.fire("Erro", "Não foi possível iniciar a conexão com o Google Calendar.", "error");
        }
    };

    const handleGoogleDisconnect = async () => {
        try {
            await HttpService.get("auth/google/disconnect");
            if (setUser) {
                setUser((prev) => ({ ...prev, is_google_connected: false }));
            }
            Swal.fire("Sucesso", "Sua agenda foi desconectada do Google Calendar.", "success");
        } catch (error) {
            console.error("Erro ao desconectar do Google:", error);
            Swal.fire("Erro", "Não foi possível desconectar do Google Calendar.", "error");
        }
    };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox p={{ xs: 0.5, md: 3 }}>
        <MDBox display="flex" flexDirection={isMobile ? "column" : "row"} justifyContent="space-between" alignItems={isMobile ? "stretch" : "center"} mb={2} gap={2}>
          <MDTypography variant="h4" mb={isMobile ? 2 : 0}>Agenda</MDTypography>

          <MDBox display="flex" flexDirection={isMobile ? "column" : "row"} gap={1}>
            {user?.is_google_connected ? (
              <MDButton
                variant="outlined"
                color="error"
                onClick={handleGoogleDisconnect}
                fullWidth={isMobile}
              >
                <Icon sx={{ mr: 1 }}>event_busy</Icon>
                Desconectar Agenda
              </MDButton>
            ) : (
              <MDButton
                variant="outlined"
                color="info"
                onClick={handleGoogleConnect}
                fullWidth={isMobile}
              >
                <Icon sx={{ mr: 1 }}>event</Icon>
                Conectar Google Calendar
              </MDButton>
            )}
            <MDButton
              variant="gradient"
              color={sidenavColor}
              onClick={() => setOpenModal(true)}
              fullWidth={isMobile}
            >
              Novo Evento
            </MDButton>
          </MDBox>
        </MDBox>

        {loading && <MDTypography>Carregando...</MDTypography>}

        {!loading && (
                  <CalendarView
                      events={calendarEvents}
                      onDateClick={(info) => {
                          // Bloquear clique em datas passadas
                          if (info.dateStr < todayDate) {
                            Swal.fire({
                              icon: "warning",
                              title: "Data no Passado",
                              text: "Não é possível criar eventos para datas que já passaram",
                              timer: 2000,
                              showConfirmButton: false,
                            });
                            return;
                          }
                          
                          setSelectedEvent(null);
                          setSelectedDate(info.dateStr);
                          setOpenModal(true);
                      }}
                      onEventClick={(info) => {
                          const eventId = info.event.id;
                          const event = schedule.find((e) => e.id === Number(eventId));

                          setSelectedEvent(event);
                          setOpenModal(true);
                      }}
                  />

        )}
      </MDBox>

          <CreateEventModal
              open={openModal}
              event={selectedEvent}
              selectedDate={selectedDate}
              selectedEvent={selectedEvent}

 
              onClose={() => {
                  setOpenModal(false);
                  setSelectedEvent(null);

              }
              }
          />

    </DashboardLayout>
  );
}

export default Schedule;